import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import BottomBarItem from '../../../../../components/BottomBarItem';
import theme from '../../../../../assets/styles/theme/theme';
import { ButtonContainer, Container, DescriptionContainer } from './styles';
import { Button } from '@gerdau/hefesto/Button';
import { useDispatch, useSelector } from 'react-redux';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { ApplicationState } from '../../../../../store';
import { useHistory } from 'react-router-dom';

interface OrderSettingsFloatBarProps {
  itensQuantity: number;
  onConfirmClick(): void;
  totalQuantity?: string;
  notFoundItems?: number;
  disabledConfirmButton?: boolean;
  isShoppingCartFloatBar?: boolean;
  numberMaxOfItens?: number;
}

const OrderSettingsBottomBar: React.FC<OrderSettingsFloatBarProps> = ({
  itensQuantity,
  totalQuantity,
  notFoundItems,
  onConfirmClick,
  disabledConfirmButton = false,
  numberMaxOfItens
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const taggingInfoPreviousScreen = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const modalContentMessage = notFoundItems
    ? `O${notFoundItems > 1 ? 's' : ''} ${
        notFoundItems > 1 ? notFoundItems : ''
      } ite${notFoundItems > 1 ? 'ns' : 'm'} 
            que não fo${notFoundItems > 1 ? 'ram' : 'i'} identificado${
        notFoundItems > 1 ? 's' : ''
      } não ser${notFoundItems > 1 ? 'ão' : 'á'} 
            adicionado${notFoundItems > 1 ? 's' : ''}  ao carrinho.`
    : '';

  const goToBack = () => {
    history.goBack();
  };

  const onConfirm = () => {
    if (notFoundItems && notFoundItems > 0) {
      Modal.confirm({
        title: 'Atenção',
        icon: <ExclamationCircleOutlined />,
        content: modalContentMessage,
        okText: 'Concordar e prosseguir',
        cancelText: 'Voltar e revisar',
        onOk: onConfirmClick
      });
    } else {
      onConfirmClick();
    }
  };

  return (
    <Container>
      <DescriptionContainer>
        <BottomBarItem
          title="Quantidade de itens"
          description={
            numberMaxOfItens ? (
              itensQuantity <= numberMaxOfItens ? (
                `${itensQuantity}/${numberMaxOfItens}`
              ) : (
                <span
                  style={{ color: theme.colors.red }}
                >{`${itensQuantity}/${numberMaxOfItens}`}</span>
              )
            ) : (
              itensQuantity
            )
          }
        />

        {totalQuantity !== undefined && (
          <BottomBarItem
            title="Total"
            description={Number(totalQuantity) > 0 ? `${totalQuantity} t` : '0'}
          />
        )}
      </DescriptionContainer>

      <ButtonContainer>
        {numberMaxOfItens && itensQuantity > numberMaxOfItens && (
          <span className="max-itens-excedeed">
            O número máximo de itens por pedido é <b>{numberMaxOfItens}</b>
          </span>
        )}

        <Button
          name="backButton"
          variant="secondary"
          onClick={() => {
            dispatch(
              sendTagging({
                screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:Detalhamento`,
                event: 'click',
                filterInfo: `#codEmr:${
                  shoppingCartState.emitterId
                    ? shoppingCartState.emitterId
                    : 'not_set'
                }#codRbd:${
                  shoppingCartState.receiverId
                    ? shoppingCartState.receiverId
                    : 'not_set'
                }`,
                itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_detalhamento_voltar`,
                product: `${
                  shoppingCartState.items.length
                    ? shoppingCartState.items
                        .map((item) => (item.sku ? item.sku : item.customerSku))
                        .join(',')
                    : 'not_set'
                }`,
                orderCliente: shoppingCartState.customerOrder
                  ? shoppingCartState.customerOrder
                  : 'not_set'
              })
            );
            goToBack();
          }}
        >
          Voltar
        </Button>

        <Button
          name="reviewOrderButton"
          variant="primary"
          onClick={() => {
            dispatch(
              sendTagging({
                screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:Detalhamento`,
                event: 'click',
                filterInfo: `#codEmr:${
                  shoppingCartState.emitterId
                    ? shoppingCartState.emitterId
                    : 'not_set'
                }#codRbd:${
                  shoppingCartState.receiverId
                    ? shoppingCartState.receiverId
                    : 'not_set'
                }`,
                itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_detalhamento_revisarPedido`,
                itemName: 'button:revisarPedido',
                product: `${
                  shoppingCartState.items.length
                    ? shoppingCartState.items
                        .map((item) => (item.sku ? item.sku : item.customerSku))
                        .join(',')
                    : 'not_set'
                }`,
                orderCliente: shoppingCartState.customerOrder
                  ? shoppingCartState.customerOrder
                  : 'not_set'
              })
            );
            onConfirm();
          }}
          disabled={
            disabledConfirmButton ||
            (numberMaxOfItens !== undefined && itensQuantity > numberMaxOfItens)
          }
        >
          Revisar pedido
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default OrderSettingsBottomBar;
